import React, { useEffect } from 'react';
import { AddIcon } from 'cokitchen-icons';
import useEventDetailsContext from 'contexts/event-details.context';
import CurrencyInput from 'components/base/currency-input';
import { Input } from '@cokitchen/cokitchen-components';
import { GuestDetailsType } from 'models/guest.model';

const defaultData = () => {
  return {
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
    budget: ''
  };
};

type AddNewGuestProps = {
  guestData: GuestDetailsType;
  setGuestData: (guestData: GuestDetailsType) => void;
  handleDelete: () => void;
  showRemoveButton: boolean;
};

const AddGuestForm = (props: AddNewGuestProps) => {
  const { setIsFormEmpty } = useEventDetailsContext();
  const { guestData, setGuestData, handleDelete, showRemoveButton } = props;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { name, value } = target;
    setGuestData({
      ...guestData,
      [name]: value
    });
    setIsFormEmpty(false);
  };
  return (
    <div className='max-w-[396px] text-sm space-y-4 border-b border-[#E9EAEC]'>
      {showRemoveButton && (
        <div
          onClick={handleDelete}
          className='text-[#E60A2B] text-sm my-2 cursor-pointer max-w-[110px] float-right'>
          - <span>Remove guest</span>
        </div>
      )}

      <div className='flex gap-2 flex-wrap w-full justify-between'>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='text'
            label='First Name'
            name='first_name'
            value={guestData.first_name}
            onChange={handleChange}
            placeholder='Enter a name'
            className='mb-3'
          />
        </div>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='text'
            label='Last Name'
            name='last_name'
            value={guestData.last_name}
            onChange={handleChange}
            placeholder='Enter a name'
            className='mb-3'
          />
        </div>
      </div>
      <div className='flex gap-2 flex-wrap w-full justify-between'>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='text'
            label='Email'
            name='email'
            value={guestData.email}
            onChange={handleChange}
            placeholder='Enter guest email'
            className='mb-3'
          />
        </div>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='phone'
            label='Phone number'
            name='mobile_number'
            value={guestData.mobile_number}
            onChange={handleChange}
            placeholder='Phone number'
            className='mb-3'
          />
        </div>
      </div>
      <CurrencyInput
        label='Set a budget'
        value={guestData.budget}
        onChange={(budget) => {
          setGuestData({
            ...guestData,
            budget
          });
        }}
        placeholder='50,000'
      />
    </div>
  );
};

const AddGuestManually = () => {
  const { formData, setFormData, active } = useEventDetailsContext();
  useEffect(() => {
    if (formData?.guests.length === 0) {
      setFormData({
        ...formData,
        guests: [defaultData()]
      });
    }
  }, [formData?.guests]);

  return (
    <div>
      <div>
        {active === 'manual' &&
          formData?.guests.map((item, index) => (
            <AddGuestForm
              key={index}
              guestData={item}
              handleDelete={() => {
                setFormData({
                  ...formData,
                  guests: formData.guests.filter((itm, i) => i !== index)
                });
              }}
              setGuestData={(newForm) => {
                setFormData({
                  ...formData,
                  guests: formData.guests.map((itm, i) => {
                    if (i === index) {
                      return newForm;
                    }
                    return itm;
                  })
                });
              }}
              showRemoveButton={index !== 0}
            />
          ))}
      </div>
      <div
        className='text-[#0080E5] flex items-center gap-[2px] text-sm font-medium cursor-pointer my-4'
        onClick={() => {
          setFormData({
            ...formData,
            guests: [...formData.guests, defaultData()]
          });
        }}>
        <AddIcon className='w-5 h-5' />
        <span>Add guest</span>
      </div>
    </div>
  );
};

export default AddGuestManually;
